'use client'

import { Teams } from '@glovo/organisation'
import { APIProvider } from '@vis.gl/react-google-maps'
import type { FC } from 'react'
import { AddressBookProvider } from '../AddressBookContext'
import type { UserAddress, UserAddressNew } from '../entities'
import { getConfig } from '@/tools/config'
import { withErrorBoundary } from '@/tools/o11y/client'
import { useDeviceMedia } from '@/tools/ui'
import { AddressBookDesktop } from '@/user/address-book/ui/components/address-book-desktop/AddressBookDesktop'
import { AddressBookMobile } from '@/user/address-book/ui/components/address-book-mobile/AddressBookMobile'

interface Props {
  onClose: () => void
  onSelect: (address: UserAddress | UserAddressNew) => void
}

export const AddressBook: FC<Props> = withErrorBoundary(
  ({ onClose: handleOnClose, onSelect: handleOnSelect }) => {
    const { isMobile } = useDeviceMedia()

    const { googleMapsKey } = getConfig()

    return (
      <AddressBookProvider>
        <APIProvider apiKey={googleMapsKey}>
          {isMobile ? (
            <AddressBookMobile onClose={handleOnClose} onSelect={handleOnSelect} />
          ) : (
            <AddressBookDesktop onClose={handleOnClose} onSelect={handleOnSelect} />
          )}
        </APIProvider>
      </AddressBookProvider>
    )
  },
  {
    id: 'user.address_book.root',
    owner: Teams.WEBX,
  }
)
